import { getApi, postApi, fetchApi } from '@coconut/services/apis/utils';

const fetchChats = (QID) =>
  getApi(`api/v2/questions/${QID}/messages`).then((res) => res);

const sendChatMessage = (QID, messageInfo) =>
  postApi(`api/v2/questions/${QID}/messages`, {
    data: messageInfo, // it doesn't care what type of message it sends out.
  }).then((res) => res);

const getQuestion = (QID) =>
  getApi(`api/v2/questions/${QID}`).then((res) => res);

export const getQuestionStageExpiration = (QID) =>
  getApi(`api/v2/questions/${QID}/stage_expiration`).then((res) => res);

const rejectTutor = (userID, QID) =>
  fetchApi(`api/v2/students/${userID}/questions/${QID}/reject`, 'PATCH').then(
    (res) => res
  );

const acceptTutor = (userID, QID) =>
  fetchApi(`api/v2/students/${userID}/questions/${QID}/accept`, 'PATCH').then(
    (res) => res
  );

const endSession = (QID) =>
  fetchApi(`api/v2/questions/${QID}/finish`, 'PATCH').then((res) => res);

const getTutorStatics = (tutorID) =>
  getApi(`api/v2/tutors/${tutorID}/statistical_data`).then((res) => res);

export const setAnswerStage = ({ QID, action }) =>
  fetchApi(`api/v2/questions/${QID}/transform_stage`, 'PATCH', {
    data: {
      action,
    },
  }).then((res) => res);

const readMessage = ({ QID, userID, messageID }) =>
  postApi(`api/v2/tutors/${userID}/questions/${QID}/read`, {
    data: {
      message_id: messageID,
    },
  });

const readQuestion = (QID) => postApi(`api/v2/questions/${QID}/read`);

const getTaggableSubtopics = (QID) =>
  getApi(`api/v2/questions/${QID}/subtopics`).then((res) => res.data);

const updateTaggableSubtopics = ({ QID, subtopicIds }) =>
  fetchApi(`api/v2/questions/${QID}/subtopics`, 'PATCH', {
    data: {
      subtopic_ids: subtopicIds,
    },
  }).then((res) => res.data);

export default {
  fetchChats,
  sendChatMessage,
  getQuestion,
  rejectTutor,
  acceptTutor,
  endSession,
  getTutorStatics,
  getQuestionStageExpiration,
  setAnswerStage,
  readMessage,
  readQuestion,
  getTaggableSubtopics,
  updateTaggableSubtopics,
};



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/apis/chat.js